import { Component, ChangeDetectorRef } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { SupervisionService } from '../../modules/services/supervision';
import { UserDetail, UserService } from '../../modules/shared/user.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { skip, finalize } from 'rxjs/operators';
import * as fromSmryModels from '../../modules/models/supervision-model';
import { IKeyValue } from '../../modules/models/common-model';
import * as fromEnums from '../../modules/shared/common-enums';
import { Utils } from '../../modules/shared/utils';
import { LoaderService } from '../../modules/shared/loader/loader.service';
import { ExcelExportService } from '../../modules/shared/excel-export.service';
@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.html',
  styleUrl: './home.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class Home {

  viewType: string = 'month';
  selectedValue: number= 0;
   _issuper = false;
  loggedInUser: UserDetail | undefined;
  userSub!: Subscription;
  repIdsSub!: Subscription;
  //advTree: fromModels.TodoItemNode[] = [];
  criteria: any = { isSuperUser:false , years:[],repIds:[],reportRole:'' };
  years:number[] = [];
  selYear = new Date().getFullYear();
  smryResponse:fromSmryModels.SupervisionSmryResponse | undefined;
  smryByYear:fromSmryModels.RptYearCount | undefined;
  smryByRptType:fromSmryModels.SmryByRptType[] = [];
  reportTypes: IKeyValue[] = [];
  alertDescriptions: string[] = [];
  alertColorMap: { [groupCode: string]: { [alertDesc: string]: string } } = {};
  openBucketTotals: { [desc: string]: number } = {};
  private lastSummaryRequestKey = '';
  private hasCompletedInitialSummaryLoad = false;
  private initialSummaryLoadInProgress = false;
  private hasLoggedUser = false;

  isSmryMode = true; 

constructor(
    private superVisionsvc: SupervisionService,
    private userSvc: UserService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  private loaderService: LoaderService,
  private excelSvc: ExcelExportService
  ) { 
    for(let i = this.selYear; i >= 2021; i--){
        this.years.push(i);
      }
      // Set latest year as default selected value
      if (this.years.length > 0) {
        this.selectedValue = this.years[0];
      }
  }

  ngOnInit(): void {
      this.userSvc.traceMsg("Supervision summary component - Init");

    // Capture any repIds already set (e.g. navigating back from Report with advisors selected)
    this.criteria.repIds = this.userSvc.repIds$.getValue();

    this.userSub = this.userSvc.userSubject.subscribe(d => {
      if (d) {        
        const roleChanged = this.loggedInUser?.role !== d.role || this.loggedInUser?.roleApplied !== d.roleApplied;
        this.loggedInUser = d;

        if (!this.hasLoggedUser) {
          this.hasLoggedUser = true;
        }
       
        if(this.loggedInUser?.role === fromEnums.USERROLE.SUPER 
          || this.loggedInUser?.role === fromEnums.USERROLE.COMP){
          this._issuper = true;
         }
        // Force a summary reload when the active role changes (e.g. after Apply).
        if (roleChanged) {
          this.lastSummaryRequestKey = '';
        }
         this.GetSummaryData();
         this.loadAlertDescriptions();
      }     
      
    });

    // skip(1) skips the BehaviorSubject's initial replay; only react to actual filter changes
    this.repIdsSub = this.userSvc.repIds$.pipe(skip(1)).subscribe(repIds => {
      this.criteria.repIds = repIds;
      this.GetSummaryData();
    });        
  }

  ngOnDestroy(): void {
    this.userSvc.traceMsg("Supervison summary component - Destroyed");
    if (this.userSub && this.userSub !== null) {
      this.userSub.unsubscribe();
    }
    if (this.repIdsSub) {
      this.repIdsSub.unsubscribe();
    }
  }

protected GetSummaryData(){
    this.criteria.years = [];   
    this.criteria.years.push(this.selectedValue);
    this.criteria.isSuperUser = this._issuper;
    // Send reportRole only after the role is explicitly applied via the Apply button.
    this.criteria.reportRole = this.loggedInUser?.roleApplied ? (this.loggedInUser?.role || '') : '';

    const repIds = Array.isArray(this.criteria.repIds) ? [...this.criteria.repIds] : [];
    repIds.sort();
    const requestKey = [
      this.loggedInUser?.userid || '',
      this.criteria.reportRole || '',
      this.selectedValue,
      repIds.join(',')
    ].join('|');
    if (this.lastSummaryRequestKey === requestKey) {
      return;
    }
    this.lastSummaryRequestKey = requestKey;

    const showInitialOverlay = !this.hasCompletedInitialSummaryLoad && !this.initialSummaryLoadInProgress;
    if (showInitialOverlay) {
      this.initialSummaryLoadInProgress = true;
      this.loaderService.show();
    }

    this.superVisionsvc.getSupervisionSmry(this.criteria)
    .pipe(
      finalize(() => {
        if (showInitialOverlay) {
          this.initialSummaryLoadInProgress = false;
          this.loaderService.hide();
        }
      })
    )
    .subscribe(response =>{
      console.log(response.headers.get('X-Debug-Log'));
     this.smryResponse = response.body!;
      this.smryByYear = response.body!.smryByYear[0];
      this.smryByRptType = response.body!.smryByType;
      this.reportTypes = this.buildReportTypes(response.body);
      this.computeOpenBucketTotals();
      this.hasCompletedInitialSummaryLoad = true;
      this.cdr.detectChanges();
    },
    (err: any) =>{
      this.lastSummaryRequestKey = '';
      this.cdr.detectChanges();
      //this._snackBar.open("Error occured.", "Error", { duration: 10000, panelClass: 'error-snackbar' } as MatSnackBarConfig);
      //this.userSvc.traceMsg('Error getting supervision summary data.', err, "Error");
    });
  }

  onYearChange(): void {
    this.GetSummaryData();
  }

  onViewTypeChange(viewType: string): void {
  }

  private loadAlertDescriptions(): void {
    if (this.alertDescriptions.length > 0) return;
    this.superVisionsvc.getColorSelection().subscribe(data => {
      const seen = new Set<string>();
      const excluded = ['closed', 'deferred'];
      const colorMap: { [groupCode: string]: { [alertDesc: string]: string } } = {};
      (data || []).forEach(d => {
        const desc = d.alertDescription || (d as any).alertdescription;
        const code = d.groupCode || (d as any).groupcode;
        const color = d.fidAlertColor || (d as any).fidalertcolor;
        if (code && desc && color) {
          if (!colorMap[code]) colorMap[code] = {};
          colorMap[code][desc] = color;
        }
      });
      this.alertColorMap = colorMap;
      this.alertDescriptions = (data || []).filter(d => {
        const desc = d.alertDescription || (d as any).alertdescription;
        if (desc && !seen.has(desc) && !excluded.includes(desc.toLowerCase())) {
          seen.add(desc);
          return true;
        }
        return false;
      }).map(d => d.alertDescription || (d as any).alertdescription)
        .sort((a, b) => {
          const numA = parseInt((a.match(/\d+/) || ['999'])[0]);
          const numB = parseInt((b.match(/\d+/) || ['999'])[0]);
          return numA - numB;
        });
      this.computeOpenBucketTotals();
      this.cdr.detectChanges();
    });
  }

  zeroAsDash(value: number | string | null | undefined): number | string {
    return Utils.zeroAsDash(value);
  }

  get canExport(): boolean {
    const role = this.loggedInUser?.role;
    return role === fromEnums.USERROLE.SUPER
      || role === fromEnums.USERROLE.SUPERVISION
      || role === fromEnums.USERROLE.COMP;
  }

  private computeOpenBucketTotals(): void {
    if (!this.smryByYear?.months || !this.alertDescriptions.length) return;
    const totals: { [desc: string]: number } = {};
    for (const desc of this.alertDescriptions) {
      const field = Utils.OPEN_FIELD_MAP[desc];
      if (!field) continue;
      let sum = 0;
      for (const month of this.smryByYear.months) {
        for (const item of (month.smryItems || [])) {
          const val = item[field] ?? item[field.toLowerCase()];
          if (val !== undefined && val !== null) sum += val;
        }
      }
      totals[desc] = sum;
    }
    this.openBucketTotals = totals;
  }

  private buildReportTypes(summary: fromSmryModels.SupervisionSmryResponse | null | undefined): IKeyValue[] {
    const seen = new Set<string>();
    const result: IKeyValue[] = [];

    for (const item of summary?.reports || []) {
      const code = (item?.rptType || '').trim();
      const name = (item?.rptDesc || '').trim();
      if (!code || seen.has(code)) {
        continue;
      }
      seen.add(code);
      result.push({ key: code, value: name || code });
    }

    for (const item of summary?.smryByType || []) {
      const code = (item?.rptType || '').trim();
      if (!code || seen.has(code)) {
        continue;
      }
      seen.add(code);
      result.push({ key: code, value: code });
    }

    return result;
  }

  /**
   * Export the summary for every year into a single workbook, one sheet per year.
   * The sheet layout mirrors the current on-screen toggle (By Report Type / By Month):
   * a top summary block (Open buckets / Closed / Deferred / Total) followed by the
   * grouped detail rows. Fetches each year independently so the on-screen single-year
   * flow is left untouched.
   */
  exportToExcel(): void {
    if (!this.years.length) return;

    const baseCriteria = {
      isSuperUser: this._issuper,
      repIds: Array.isArray(this.criteria.repIds) ? [...this.criteria.repIds] : [],
      reportRole: this.loggedInUser?.roleApplied ? (this.loggedInUser?.role || '') : ''
    };

    this.loaderService.show();
    const startTime = performance.now();
    // Single request fetches every year at once (years sent comma-separated server-side).
    this.superVisionsvc.getSupervisionSmry({ ...baseCriteria, years: [...this.years] })
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe({
        next: response => {
          console.log(`Supervision summary (all years) fetched in ${Math.round(performance.now() - startTime)} ms`);
          const byYear = new Map<number, fromSmryModels.RptYearCount>();
          (response.body?.smryByYear || []).forEach(y => byYear.set(y.year, y));
          const sheets = this.years.map(year => this.buildYearSheet(year, byYear.get(year)));
          this.excelSvc.generateMultiSheetExcel(sheets, this.buildExportFileName());
        },
        error: () => {
          this._snackBar.open('Unable to export summary to Excel.', 'Close',
            { duration: 5000, panelClass: 'error-snackbar' } as MatSnackBarConfig);
        }
      });
  }

  private buildExportFileName(): string {
    const view = this.viewType === 'month' ? 'ByMonth' : 'ByReportType';
    const stamp = new Date().toISOString().slice(0, 10);
    return `SupervisionSummary-${view}-${stamp}.xlsx`;
  }

  private buildYearSheet(
    year: number,
    yearData: fromSmryModels.RptYearCount | undefined
  ): { name: string; rows: any[][]; boldRowIndices: number[] } {
    const descs = this.alertDescriptions;

    const rows: any[][] = [];
    const boldRowIndices: number[] = [];

    // --- Top summary block (mirrors the status bar) ---
    const allItems: fromSmryModels.SmryReportItem[] =
      (yearData?.months || []).reduce((acc, m) => acc.concat(m.smryItems || []), [] as fromSmryModels.SmryReportItem[]);

    boldRowIndices.push(rows.length);
    rows.push([`Summary Report : ${year}`]);
    boldRowIndices.push(rows.length);
    rows.push([`Total Reports : ${allItems.length}`]);
    rows.push([]); // spacer

    // "Report Age:" header with the status columns, counts shown on the next row.
    boldRowIndices.push(rows.length);
    rows.push(['Report Age:', ...descs, 'Closed', 'Deferred', 'Total Status']);
    rows.push([
      'Status Counts :',
      ...descs.map(desc => this.sumOpenBucket(allItems, desc)),
      Utils.zeroAsDash(yearData?.closedCt?.ct),
      Utils.zeroAsDash(yearData?.deferredCt?.ct),
      yearData?.totalCt?.ct ?? 0
    ]);
    rows.push([]); // spacer

    // --- Detail block (follows the current toggle) ---
    if (this.viewType === 'month') {
      this.appendByMonthDetail(rows, boldRowIndices, yearData, descs);
    } else {
      this.appendByReportTypeDetail(rows, boldRowIndices, this.buildByTypeFromYear(yearData), descs);
    }

    return { name: String(year), rows, boldRowIndices };
  }

  /**
   * Group a single year's monthly smryItems by report type so the By Report Type
   * sheet can be built per year from one multi-year response.
   */
  private buildByTypeFromYear(
    yearData: fromSmryModels.RptYearCount | undefined
  ): fromSmryModels.SmryByRptType[] {
    const map = new Map<string, fromSmryModels.SmryByRptType>();
    for (const m of yearData?.months || []) {
      for (const i of m.smryItems || []) {
        let group = map.get(i.rptType);
        if (!group) {
          group = {
            rptType: i.rptType,
            totalCt: 0,
            closedCt: 0,
            deferredCt: 0,
            openCt: 0,
            deferredInPrevCt: 0,
            expand: false,
            smryItems: []
          };
          map.set(i.rptType, group);
        }
        group.smryItems.push(i);
        group.totalCt += i.totalCt || 0;
        group.closedCt += i.closedCt || 0;
        group.deferredCt += i.deferredCt || 0;
        group.openCt += i.openCt || 0;
      }
    }
    for (const group of map.values()) {
      group.smryItems.sort((a, b) => (a.month || 0) - (b.month || 0));
    }
    return Array.from(map.values());
  }

  private appendByReportTypeDetail(
    rows: any[][],
    boldRowIndices: number[],
    byType: fromSmryModels.SmryByRptType[],
    descs: string[]
  ): void {
    boldRowIndices.push(rows.length);
    rows.push(['Report Type', ...descs, 'Closed', 'Deferred', 'Total']);

    for (const r of byType) {
      const label = `${r.smryItems?.[0]?.rptDesc || r.rptType} (${(r.smryItems || []).length})`;
      boldRowIndices.push(rows.length);
      rows.push([
        label,
        ...descs.map(desc => this.sumOpenBucket(r.smryItems || [], desc)),
        Utils.zeroAsDash(r.closedCt),
        Utils.zeroAsDash(r.deferredCt),
        Utils.zeroAsDash(r.totalCt)
      ]);
      for (const i of r.smryItems || []) {
        rows.push([
          `    ${i.monthName}-${i.year}`,
          ...descs.map(desc => Utils.getOpenCount(i, desc)),
          Utils.zeroAsDash(i.closedCt),
          Utils.zeroAsDash(i.deferredCt),
          Utils.zeroAsDash(i.totalCt)
        ]);
      }
    }
  }

  private appendByMonthDetail(
    rows: any[][],
    boldRowIndices: number[],
    yearData: fromSmryModels.RptYearCount | undefined,
    descs: string[]
  ): void {
    boldRowIndices.push(rows.length);
    rows.push(['Month', ...descs, 'Closed', 'Deferred', 'Total']);

    for (const m of yearData?.months || []) {
      boldRowIndices.push(rows.length);
      rows.push([
        `${m.monthName} (${(m.smryItems || []).length} reports)`,
        ...descs.map(desc => this.sumOpenBucket(m.smryItems || [], desc)),
        Utils.zeroAsDash(m.closedCt?.ct),
        Utils.zeroAsDash(m.deferredCt?.ct),
        Utils.zeroAsDash(m.totalCt?.ct)
      ]);
      for (const i of m.smryItems || []) {
        rows.push([
          `    ${i.rptDesc}`,
          ...descs.map(desc => Utils.getOpenCount(i, desc)),
          Utils.zeroAsDash(i.closedCt),
          Utils.zeroAsDash(i.deferredCt),
          Utils.zeroAsDash(i.totalCt)
        ]);
      }
    }
  }

  private sumOpenBucket(items: fromSmryModels.SmryReportItem[], desc: string): number | string {
    const field = Utils.OPEN_FIELD_MAP[desc];
    if (!field) return '--';
    let total = 0;
    for (const item of items) {
      const val = item[field] ?? item[field.toLowerCase()];
      if (val !== undefined && val !== null) total += val;
    }
    return total === 0 ? '--' : total;
  }

}